<template>
    <BaseWidget
        :title="widget.title"
        :title-url="widget.titleUrl"
        :footer="widget.footer"
        :footer-url="widget.footerUrl"
    >
        <div class="flex gap-2">
            <div class="flex-shrink-0">
                <WidgetIcon :icon="widget.content.icon" />
            </div>
            <div class="text-sm text-gray-600">
                {{ widget.content.description }}
            </div>
        </div>
        <div v-if="widget.content.buttons" class="mt-3">
            <div v-for="button in widget.content.buttons" :key="button.url" class="mt-1">
                <AppButton :href="button.url" element="a">
                    {{ button.text_button }}
                </AppButton>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import WidgetIcon from './WidgetIcon.vue';
import AppButton from '../../AppButton.vue';

export default {
    name: 'BasicWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        AppButton,
        WidgetIcon,
        BaseWidget,
    },
};
</script>
